import backend from "../../utils/backend";
import qs from "qs";
import {
  GET_SUBSCRIPTIONS,
  GET_SUBSCRIPTIONS_SUCCESS,
  GET_SUBSCRIPTIONS_ERROR,
  GET_SUBSCRIPTION,
  GET_SUBSCRIPTION_SUCCESS,
  GET_SUBSCRIPTION_ERROR,
  GET_SUBSCRIPTION_NEWSLETTERS,
  GET_SUBSCRIPTION_NEWSLETTERS_SUCCESS,
  GET_SUBSCRIPTION_NEWSLETTERS_ERROR,
  GET_NEWSLETTER,
  GET_NEWSLETTER_SUCCESS,
  GET_NEWSLETTER_ERROR } from "../../constants/actionTypes";

export const getSubscriptions = (params) => {
  return (dispatch) => {
    dispatch({
      type: GET_SUBSCRIPTIONS,
    });

    return backend.request({
      method: "GET",
      url: `/subscriptions/?${qs.stringify(params)}`,

    })
      .then((response) => {
        dispatch({
          type: GET_SUBSCRIPTIONS_SUCCESS,
          payload: response.data.results,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_SUBSCRIPTIONS_ERROR,
          payload: err,
        });
      });
  };
};

export const getNewsletter = (newsletterId) => {
  return (dispatch) => {
    dispatch({
      type: GET_NEWSLETTER,
    });

    return backend.request({
      method: "GET",
      url: `/newsletters/${newsletterId}/`,
    })
      .then((response) => {
        dispatch({
          type: GET_NEWSLETTER_SUCCESS,
          payload: response.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_NEWSLETTER_ERROR,
          payload: err,
        });
      });
  };
};

export const populateSubscription = (subscriptionId) => {
  return (dispatch) => {
    return dispatch(getSubscription(subscriptionId))
      .then(dispatch(getSubscriptionNewsletters(subscriptionId)));
  };
};

export const getSubscription = (subscriptionId) => {
  return (dispatch) => {
    dispatch({
      type: GET_SUBSCRIPTION,
    });

    return backend.request({
      method: "GET",
      url: `/subscriptions/${subscriptionId}/`,
    })
      .then((response) => {
        dispatch({
          type: GET_SUBSCRIPTION_SUCCESS,
          payload: response.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_SUBSCRIPTION_ERROR,
          payload: err,
        });
      });
  };
};

export const getSubscriptionNewsletters = (subscriptionId, page=1) => {
  return (dispatch) => {
    dispatch({
      type: GET_SUBSCRIPTION_NEWSLETTERS,
    });

    return backend.request({
      method: "GET",
      url: `/subscriptions/${subscriptionId}/newsletters/`,
      params: { page },
    })
      .then((response) => {
        dispatch({
          type: GET_SUBSCRIPTION_NEWSLETTERS_SUCCESS,
          payload: response.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_SUBSCRIPTION_NEWSLETTERS_ERROR,
          payload: err,
        });
      });
  };
};



// WEBPACK FOOTER //
// ./src/subscriptions/actions/subscriptions.js